import { SettingsOverscanOutlined } from "@mui/icons-material";
import { Slider } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTimer } from "react-timer-hook";
import { StyledButton } from "../Buttons/StyledButton";
import styled from "styled-components";
import { useToasts } from "react-toast-notifications";
import timeup from "../../audio/timeup.mp3";

const ClearButton = styled.button`
  background: none;
  border: none;
  font-size: 30px;
  padding: 10px;
  padding-right: 0px;
`;

const TimerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
  /* width: 180px; */
`;

const TimeWrapper = styled.div`
  text-align: center;
  color: white;
  display: flex;
  flex-direction: row;
  font-size: 45px;
  margin-top: 20px;
  /* width: 180px; */
`;

const Digits = styled.span`
  margin: 5px;
  align-self: center;
  /* min-width: 130px; */
  padding: 10px;
  padding-top: 15px;
`;

export default function Timer({ expiryTimestamp }) {
  const { addToast } = useToasts();
  const [sliderValue, setSliderValue] = useState(10);
  const [audio, setAudio] = useState({});
  // const audio = new Audio(timeup);
  useEffect(() => {
    setAudio(new Audio(timeup));
  }, []);
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({
    expiryTimestamp,
    onExpire: () => {
      audio.play();
      addToast("End of station", {
        appearance: "success",
        autoDismiss: false,
      });
    },
    autoStart: false,
  });

  const time = new Date();

  const handleChange = (event, newValue) => {
    time.setSeconds(time.getSeconds() + 60 * newValue);
    restart(time, false);
  };

  useEffect(() => {
    if (minutes == 0) {
      audio.play();
      addToast("One minute left", {
        appearance: "info",
        autoDismiss: false,
      });
    }
  }, [minutes]);

  return (
    <TimerWrapper>
      <TimeWrapper>
        <ClearButton onClick={isRunning ? pause : resume}>
          {isRunning ? "⏸" : "▶️"}
        </ClearButton>
        <Digits>{`${minutes <= 9 && minutes >= 1 ? "0" : ""}${minutes}:${
          seconds <= 9 ? "0" : ""
        }${seconds}`}</Digits>
      </TimeWrapper>
      <Slider
        sx={{
          marginTop: "20px",
          color: "white",
          minWidth: "180px",
        }}
        defaultValue={10}
        valueLabelDisplay="auto"
        onChange={handleChange}
        step={1}
        marks
        min={1}
        max={15}
      />
    </TimerWrapper>
  );
}
